import { gql } from '@apollo/client';

import type { ContractType } from './generated';

export const GET_CONTRACT_BALANCE = gql`
  query ContractBalances($advertiserId: String!, $advertiserNation: String!) {
    contractBalances(
      advertiserId: $advertiserId
      advertiserNation: $advertiserNation
    ) {
      adType
      contractType
      totalValue {
        dollars {
          original {
            value
            currency
          }
          remaining {
            value
            currency
          }
        }
      }
    }
  }
`;
export interface AdvertiserContract {
  contractType: ContractType;
}
